import React from 'react';
import { CheckBox, NumberInput, DropdownSelector } from 'hyperdb-utils';

const GeneralFieldset = ({ objectData, onChange }) => {
  const deposit = objectData.deposit || {};
  const securityDeposit = objectData.security_deposit || {};
  const priceRules = objectData.price_rules || {};
  const handleClickCheckbox = (attributeName) => {
    const checked = !objectData[attributeName];
    onChange(attributeName, { value: checked });
  };
  return (
    <fieldset>
      <CheckBox
        label="Direct booking allowed"
        name="direct_booking_allowed"
        checked={ objectData.direct_booking_allowed }
        onChange={ handleClickCheckbox.bind(null, 'direct_booking_allowed') }
      />
      <NumberInput
        label="Cleaning fee"
        name="cleaning_fee"
        value={ priceRules.cleaning_fee }
        onChange={ handleChangePriceRules.bind(null, onChange, objectData, 'cleaning_fee') }
      />
      <NumberInput
        label="Nb min. nights for free cleaning"
        name="nb_min_nights_free_cleaning"
        value={ priceRules.nb_min_nights_free_cleaning }
        onChange={ handleChangePriceRules.bind(null, onChange, objectData, 'nb_min_nights_free_cleaning') }
      />
      <fieldset>
        <legend>Deposit</legend>
        <DropdownSelector
          label="Type"
          name="deposit_type"
          value={ deposit.type || 1 }
          options={ depositTypesOptions() }
          onChange={ handleChangeDeposit.bind(null, onChange, objectData, 'deposit', 'type') }
        />
        {
          deposit.type && parseInt(deposit.type) !== 1
            ? <NumberInput
                label="Value"
                name="deposit_value"
                value={ deposit.value }
                onChange={ handleChangeDeposit.bind(null, onChange, objectData, 'deposit', 'value') }
              />
            : null
        }
      </fieldset>
      <fieldset>
        <legend>Security Deposit</legend>
        <DropdownSelector
          label="Type"
          name="security_deposit_type"
          value={ securityDeposit.type || 1 }
          options={ depositTypesOptions() }
          onChange={ handleChangeDeposit.bind(null, onChange, objectData, 'security_deposit', 'type') }
        />
        {
          securityDeposit.type && parseInt(securityDeposit.type) !== 1
            ? <NumberInput
                label="Value"
                name="security_deposit_value"
                value={ securityDeposit.value }
                onChange={ handleChangeDeposit.bind(null, onChange, objectData, 'security_deposit', 'value') }
              />
            : null
        }
        {
          securityDeposit.type && parseInt(securityDeposit.type) !== 1
            ? <NumberInput
                label="Refund delay"
                name="security_deposit_refund_delay"
                value={ securityDeposit.refund_delay }
                onChange={ handleChangeDeposit.bind(null, onChange, objectData, 'security_deposit', 'refund_delay') }
              />
            : null
        }
      </fieldset>
    </fieldset>
  );
};

function depositTypesOptions() {
  return [
    { name: 'none', value: 1 },
    { name: 'percentage of total price without cleaning fee', value: 2 },
    { name: 'percentage of total price with cleaning fee', value: 3 },
    { name: 'fixed amount per day', value: 4 },
    { name: 'flat amount per stay', value: 5 },
  ];
}

function handleChangePriceRules(cb, objectData, attributeName, field) {
  const { name, value } = field;
  const priceRules = { ...objectData.price_rules || {} };
  priceRules[attributeName] = value;
  cb('price_rules', { value: priceRules });
}
function handleChangeDeposit(cb, objectData, objectName, attributeName, field) {
  const { name, value } = field;
  const deposit = { ...objectData[objectName] || {} };
  deposit[attributeName] = value;
  cb(objectName, { value: deposit });
}

export default GeneralFieldset;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/GeneralFieldset.jsx